import { Icon, IconName } from '@usealloy/component-library';
import React from 'react';

import type { InputAttributeNode as IInputAttributeNode, WorkflowNodeProps } from 'flow/service/graph';

import BaseNode from '../BaseNode';
import { getAttributeNodeIcon } from '../BaseNode/helpers';
import { useAppSelector } from '~/store/reduxHooks';
import { selectCustomTransactionAttributesEnabled } from '~/dashboard/views/workflows/store/redux/selectors/general';
import { selectHasNodeContainers } from 'flow/store/redux/selectors';


function InputAttributeNode(props: WorkflowNodeProps<IInputAttributeNode>) {
  const { id, type, data: { isPublishedAttribute, label, objectType } } = props;

  const { hasNodeFolder } = useAppSelector(selectHasNodeContainers);
  const customTransactionAttributesEnabled = useAppSelector(
    selectCustomTransactionAttributesEnabled,
  );

  const iconName = getAttributeNodeIcon({
    defaultIcon: IconName.Input,
    isPublishedAttribute,
    objectType,
    customTransactionAttributesEnabled,
  });

  return (
    <BaseNode
      icon={
        <Icon icon={iconName} size="large" />
      }
      id={id}
      isChildNode={hasNodeFolder}
      label={label}
      stateStyle={{
        baseBackgroundColor: 'var(--cl-juicyBlue-100)',
        hovered: {
          backgroundColor: 'var(--cl-juicyBlue-200)',
        },
      }}
      type={type}
    />
  );
}

export default React.memo(InputAttributeNode);
